/**
 * Minified by jsDelivr using Terser v5.3.5.
 * Original file: /npm/segmentit@2.0.3/dist/umd/segmentit.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
